/*
 * Digital Slide Conferencing jQuery plugin
 */
(function ($) {
    $.fn.conference = function (method)
    {
        var debug = false;

        // name space for bound digital slide conference events
        var eventNameSpace = ".dsc";
        // Create x2js instance with default config
        var x2js = x2js || new X2JS();

        /*
         * conference API methods
         */
        var methods = {
            init: confInit,
            create: confCreate,
            join: confJoin,
            close: confClose
        };

        if (methods[method])
        {
            // a known method is being called, call it and pass arguments[1..n]
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        }
        else if (typeof method === 'object' || !method)
        {
            // Default to 'init' method
            return methods.init.apply(this, arguments);
        }
        else
        {
            $.error('Method "' + method + '" does not exist in jQuery.conference');
        }

        /********************************************************************************************
         * conference API method implementations
         ********************************************************************************************/

        /**
         * Conference invitation
         * @param participant
         * @returns object
         */
        function confInit(participant)
        {
            dscConsoleLog('confInit');
            if (participant)
            {
                $.extend(_participant, participant);
            }
            return this;
        }
        /*
         * Create a conference
         * @param object DSCSettings = {
         *          authToken:
         *          confManagerDivId:
         *          dscId:
         *          dscName:
         *          fullName:
         *          userId:
         *          vilDivId:
         *          }
         * @returns this
         */
        function confCreate(DSCSettings)
        {
            dscConsoleLog('confCreate');

            resetParticipant(true);
            addConfMessageHandlers();
            _participant.isLeader = true;
            bindConfEvents();
            // createConference is in DSCClientVil.js
            createConference(DSCSettings);
            return this;
        }
        /*
         * Join a conference
         * @param object DSCSettings = {
         *          authToken:
         *          confManagerDivId:
         *          dscId:
         *          dscName:
         *          fullName:
         *          userId:
         *          vilDivId:
         *          }
         * @returns this
         */
        function confJoin(DSCSettings)
        {
            dscConsoleLog('confJoin');
            resetParticipant(true);
            addConfMessageHandlers();
            // joinConference is in DSCClientVil.js
            // NOTE!!! This has same name as joinConference in conference.js
            joinConference(DSCSettings);
            // tell uScope leader join the conference
            if (_participant.isLeader)
            {
                $(document).trigger(confEvent.join, {src: 'Vil', lead: _participant.isLeader, userName: _participant.ptName});
            }
            return this;
        }
        /*
         * Close a conference
         * @returns this
         */
        function confClose()
        {
            dscConsoleLog('confClose');

            // unbind the conference events
            _participant.isLeader = false;
            bindConfEvents();
            // leaveConference is in DSCClientVil.js
            return leaveConference();
        }


        /********************************************************************************************
         * private methods
         ********************************************************************************************/

        /**
         * Log a console message
         * @param msg
         */
        function dscConsoleLog(msg)
        {
            if (window.console && debug)
            {
                console.log(msg);
            }
        }
        /*
         * add the conference message handlers
         */
        function addConfMessageHandlers()
        {
            g_dscClient.addDSCMessageHandler(_dscMessageTypes.confManagementMessage, confMessageRouter);
            g_dscClient.addDSCMessageHandler(_dscMessageTypes.confAttributeMessage, confMessageRouter);
        }
        /*
         * Conference message router. 
         * Receives conference messages and responses, and triggers events based on the response
         * 
         * @param string respType
         * @param XML dscRoot
         */
        function confMessageRouter(respType, dscRoot)
        {
            dscConsoleLog('jquery.conference.js message router: ' + respType);
            // Local aliases for conferenc objects
            var conferenceObj = leica.pi.util.conference;
            
            switch (respType) {
                case "New Conference Response":
                    // trigger a join conference, which is what uScope is waiting for
                    if (_participant.isLeader)
                    {
                        var confObject =
                                {
                                    src: 'Vil',
                                    lead: _participant.isLeader,
                                    userName: _participant.ptName
                                };
                        $(document).trigger(confEvent.join, confObject);

                        //set the conference type and record using the conference module
                        _participant.conferenceType = getLocalConferenceType();
                        _participant.conferenceTopLevelPrimaryKey = conferenceObj.dstCurrentRecordId();

                        // tell the conference server the type of conference and the primary key for top level hierarchy
                        sendConfTypeInformationAttributeJson(_participant);
                    }
                    break;
                case "Join Conference Response":
                    bindConfEvents();
                    if (!_participant.isLeader) {
                        // now send a Get Conference Attribute message
                        sendGetConferenceAttributeMessage();
                    }
                    break;
                case "Get Conference Attributes Response":
                    if (!_participant.isLeader)
                    {
                        //get the conference type and primary key from dsc
                        var conferenceInfo = getConfTypeAttributeJson(dscRoot);

                        // Update the participant information
                        _participant.conferenceType = conferenceInfo._ConferenceType;
                        _participant.conferenceTopLevelPrimaryKey = conferenceInfo._ConferenceTopLevelPrimaryKey;

                        switch (_participant.conferenceType)
                        {
                            case _conferenceTypes.CASE:
                                leica.pi.esm.conferencing.createEsmPopUpConference(
                                        dscRoot,
                                        buildConfImageAttributeJson,
                                        _participant.conferenceTopLevelPrimaryKey,
                                        _participant.confId,
                                        _participant.ptUserId,
                                        conferenceObj.userId(),
                                        conferenceObj.fullName(),
                                        conferenceObj.authToken(),
                                        conferenceObj.viewerSettingsURL
                                        );
                                break;
                            case _conferenceTypes.STUDY:

                                // Load peerreview conferencing stuff if not already present
                                // TODO: retrieve asset URLs via ajax call to server? Alternatively, move this app specific code out of conferencing package
                                var promise1 = {}, promise2 = {}; // note that $.when will treat a plain JS object as a resolved deferred
                                // If something needs to load before the peer review conferencing js, use promise1

                                if (typeof leica.pi.peerreview === "undefined") {
                                    var docRoot = '/packages/leica/';
                                    //$('<link rel="stylesheet" type="text/css" href="' + docRoot + 'peerreview/stylesheets/peerreview.css" >').appendTo("head");
                                    promise2 = $.when(promise1).then(function () {
                                        return $.getScript(docRoot + 'peerreview/javascripts/peerreview-conferencing.js');
                                    });
                                }

                                // When everything needed has been loaded, launch the conference
                                $.when(promise1, promise2).done(function () {
                                    leica.pi.peerreview.conferencing.createPeerReviewPopUpConference(
                                            dscRoot,
                                            buildConfImageAttributeJson,
                                            _participant.conferenceTopLevelPrimaryKey,
                                            _participant.confId,
                                            _participant.ptUserId,
                                            conferenceObj.userId(),
                                            conferenceObj.fullName(),
                                            conferenceObj.authToken()

                                            );
                                }).fail(function () {
                                    console.log("Error: Unable to load peer review conferencing assets.");
                                });
                                break;
                        }
                    }
                    break;
                case "Close Conference Response":
                    $(document).trigger(confEvent.exit, {src: 'Vil'});
                    break;
                case "Insert Conference Attribute":
                case "Update Conference Attribute":
                    if (!_participant.isLeader)
                    {
                        var json = buildConfImageAttributeJson($(dscRoot));
                        $(document).trigger(confEvent.update, json);
                    }
                    else
                    {
                        if (_conferenceTypes.STUDY === _participant.conferenceType)
                        {
                            leica.pi.peerreview.conferencing.becameLeader();
                        }
                        else
                        {
                            leica.pi.esm.conferencing.becameLeader();
                        }
                    }
                    break;
                case "New Leader":
                    var newLeaderName = dscRoot.getElementsByTagName("Participant")[0].attributes.getNamedItem("Name").value;
                    _participant.isLeader = _participant.ptName === newLeaderName;
                    var json = {src: 'Vil', lead: _participant.isLeader};
                    $(document).trigger(confEvent.leadChange, json);
                    bindConfEvents();
                    break;
                case "Assign Leadership Response":
                    //the leader has assigned control -- becoming a follower
                    if (_conferenceTypes.STUDY === _participant.conferenceType)
                    {
                        leica.pi.peerreview.conferencing.becameFollower();
                    }
                    else
                    {
                        leica.pi.esm.conferencing.becameFollower();
                    }
                    break;
                case "Grab Leadership Response":
                    //the leader has taken back control
                    if (_conferenceTypes.STUDY === _participant.conferenceType)
                    {
                        leica.pi.peerreview.conferencing.becameLeader();
                    }
                    else
                    {
                        leica.pi.esm.conferencing.becameLeader();
                    }
                    break;
                    // these messages are unused 
                    // cindy says that these messages come from DSC
                    // but do not need to be handled here
                    // they are handled in dscclientvil.js
                case "Update Conference Attribute Response":
                case "New Participant Response":
                case "List Conferences Response":
                case "Insert Conference Attribute Response":
                case "Update Conference Attribute Response":
                case "Delete Conference Attribute Response":
                case "Leave Conference Response":
                case "Add Participant":
                    break;
            }
        }

        function getLocalConferenceType() {
            // return the conference type
            return leica.pi.util.conference.isPeerReviewPage() ? _conferenceTypes.STUDY : _conferenceTypes.CASE;
        }

        /*
         * Send conference type attribute JSON
         * This message tells the conference server what type of conference [Case,Study] is being used         
         *  TODO: refactor; this function has global side effects         
         */
        function sendConfTypeInformationAttributeJson(p)
        {
            if (!p.isLeader)
            {
                return;
            }
            var msgDoc = createXMLDocument("temp");
            var plistNd = buildPathListNode(msgDoc, "//Attribute_List");
            var alistNd = buildAttrListNode(msgDoc);

            var confTypeNode = buildConferenceTypeNode(msgDoc, p.conferenceType);
            alistNd.appendChild(confTypeNode);

            var confTopLevelPkNode = buildConferenceTopLevelPrimaryKeyNode(msgDoc, p.conferenceTopLevelPrimaryKey);
            confTypeNode.appendChild(confTopLevelPkNode);

            // use this type to insure this message is sent
            var msgType = _dscMessageTypes.confAttributeMessage;
            sendConferenceAttributeMessage("Insert", plistNd, alistNd, msgType);
        }
        /*
         * get conferencing attribute JSON
         * 
         * @param DOM node
         * @returns json
         */
        function getConfTypeAttributeJson(node)
        {
            var json = {src: 'Vil'};
            var confType = $(node).find('ConferenceType');
            var confPrimaryKey = $(node).find('ConferenceTopLevelPrimaryKey');
            if (confType.length > 0)
            {
                $.extend(json, x2js.xml2json(confType[0]));
            }
            if (confPrimaryKey.length > 0)
            {
                $.extend(json, x2js.xml2json(confPrimaryKey[0]));
            }
            return json;
        }

        /*
         * build attribute JSON
         * 
         * @param DOM element node
         * @returns json
         */
        function buildConfImageAttributeJson(node)
        {
            var json = {src: 'Vil'};
            var position = $(node).find('Position');
            var marker = $(node).find('Marker');
            var angleDeg = $(node).find('angleDeg');

            if (position.length > 0)
            {
                $.extend(json, x2js.xml2json(position[0]));
            }
            if (marker.length > 0)
            {
                $.extend(json, x2js.xml2json(marker[0]));
            }
            if (angleDeg.length > 0)
            {
                $.extend(json, x2js.xml2json(angleDeg[0]));
            }            
            return json;
        }
        /*
         * event handlers for conference events that are triggered by uScope
         */
        function bindConfEvents()
        {
            // For 12.4.4 use pidash. 12.5+ uses lodash.
            var maybeForceRender = window.piDash.once(function () {
                function imageReadyHandler() {
                    uScope.getLegacyUScope().getThisImage().viewRefreshForce();
                    $(document).off('us_evIMAGEREADY', imageReadyHandler);
                }
                $(document).on('us_evIMAGEREADY', imageReadyHandler);
            });

            // both followers and leaders need this event
            $(document).on(confEvent.exit + eventNameSpace, function (event, parms) {
            });

            // following events are for the leader only
            if (_participant.isLeader)
            {
                // as the leader, unbind the follower conference events
                $(document).off(confEvent.imageChange + eventNameSpace);

                // the following events are needed by the leader only
                $(document).on(confEvent.openimage + eventNameSpace, function (event, parms) {
                    dscConsoleLog('confEvent.openimage x = ' + parms.x + ' y = ' + parms.y + ' zoom = ' + parms.zoom + ' angle = ' + parms.angleDeg + ' url = ' + parms.imagePath);
                    sendViewOpenMessage(parms);
                });
                $(document).on(confEvent.view + eventNameSpace, function (event, parms) {
                    sendViewChangeMessage(parms);
                });
                // as a conference leader, uScope fires the marker event to report the user's cursor position
                // The leader uScope fires it, the follower uScope listens for it (issued by follower VIL)
                $(document).on(confEvent.marker + eventNameSpace, function (event, parms) {
                    sendMarkerChangeMessage(parms);
                });
            }
            else
            {
                // not the leader, unbind the leader conference events
                $(document).off(confEvent.view + eventNameSpace)
                        .off(confEvent.marker + eventNameSpace);

                // as a conference follower, uScope fires the imageChange event to report that a new image has been opened by the leader
                // The response is to inform the follower slide tray to select the specified image
                //      parms: {src: "uScope", imageId: @NUM } 
                $(document).on(confEvent.imageChange + eventNameSpace, function (event, parms) {
                    $.getDstInstance().selectImageByImageId(parms.imageId.substring(1));
                });
            }
        }

        function sendViewChangeMessage(parms)
        {
            if (!_participant.isLeader)
            {
                return;
            }
            var msgDoc = createXMLDocument("temp");
            var plistNd = buildPathListNode(msgDoc, "//Attribute_List/Image[1]/Position[1]");
            var alistNd = buildAttrListNode(msgDoc);
            var posNd = buildPositionNode(msgDoc, parms);       // image position
            alistNd.appendChild(posNd);

            var msgType = _dscMessageTypes.confImagePositionUpdateMessage;      // use this type to signal DSC to send the latest of this type
            sendConferenceAttributeMessage("Update", plistNd, alistNd, msgType); // send the position update conference attribute message
        }
        function sendMarkerChangeMessage(parms)
        {
            if (!_participant.isLeader)
            {
                return;
            }
            var msgDoc = createXMLDocument("temp");
            var plistNd = buildPathListNode(msgDoc, "//Attribute_List/Image[1]/Marker[1]");
            var alistNd = buildAttrListNode(msgDoc);
            var mrkNd = buildMarkerNode(msgDoc, parms);
            alistNd.appendChild(mrkNd);

            var msgType = _dscMessageTypes.confMarkerPositionUpdateMessage;     // use this type to signal DSC to send the latest of this type
            sendConferenceAttributeMessage("Update", plistNd, alistNd, msgType); // send the position update conference attribute message
        }

        //
        // open uScope conference - soon to be deprecated
        //
        function sendViewOpenMessage(parms)
        {
            if (!_participant.isLeader)
            {
                return;
            }

            var msgDoc = createXMLDocument("temp");
            var plistNd = buildPathListNode(msgDoc, "//Attribute_List");
            var alistNd = buildAttrListNode(msgDoc);
            var imgNode = buildImageNode(msgDoc, parms);        // image path
            alistNd.appendChild(imgNode);
            var posNd = buildPositionNode(msgDoc, parms);       // image position
            imgNode.appendChild(posNd);
            var mrkNd = buildMarkerNode(msgDoc, parms);         // marker
            imgNode.appendChild(mrkNd);

            var msgType = _dscMessageTypes.confAttributeMessage; // use this type to insure this message is sent
            sendConferenceAttributeMessage("Insert", plistNd, alistNd, msgType); // send the open image conference attribute message
        }

        function sendGetConferenceAttributeMessage()
        {
            var msgDoc = createXMLDocument("temp");
            var dataNd = msgDoc.createElement("Data");
            g_dscClient.sendDSCMessage("Get Conference Attributes", dataNd, _dscMessageTypes.confManagementMessage);
        }

        function buildPathListNode(msgDoc, textContent)
        {
            var plistNd = msgDoc.createElement("Path_List");
            var pathNd = msgDoc.createElement("Path");
            setXMLNodeText(pathNd, textContent);
            //  pathNd.textContent = "//Attribute_List";
            plistNd.appendChild(pathNd);
            return plistNd;
        }

        function buildAttrListNode(msgDoc)
        {
            var alistNd = msgDoc.createElement("Attribute_List");
            return alistNd;
        }

        function buildPositionNode(msgDoc, parms)
        {
            var posNd = msgDoc.createElement("Position");
            for (var prop in parms) {
                if (typeof parms[prop] != 'undefined') {    // parms[prop] could be zero, with is falsy, so test for undefined explicitly
                    var element = msgDoc.createElement(prop);
                    setXMLNodeText(element, parms[prop]);
                    posNd.appendChild(element);
                }
            }
            return posNd;
        }
        function buildMarkerNode(msgDoc, parms)
        {
            var mrkNd = msgDoc.createElement("Marker");
            for (var prop in parms) {
                if (typeof parms[prop] != 'undefined') {    // parms[prop] could be zero, with is falsy, so test for undefined explicitly
                    var element = msgDoc.createElement(prop);
                    setXMLNodeText(element, parms[prop]);
                    mrkNd.appendChild(element);
                }
            }
            return mrkNd;
        }

        function buildConferenceTypeNode(msgDoc, confType)
        {
            var conferenceTypeNode = msgDoc.createElement("ConferenceType");
            conferenceTypeNode.setAttribute("ConferenceType", confType);
            return conferenceTypeNode;
        }

        function buildConferenceTopLevelPrimaryKeyNode(msgDoc, key)
        {
            var confTopLevelPkNode = msgDoc.createElement("ConferenceTopLevelPrimaryKey");
            confTopLevelPkNode.setAttribute("ConferenceTopLevelPrimaryKey", key);
            return confTopLevelPkNode;
        }

        function buildImageNode(msgDoc, parms)
        {
            var imgNode = msgDoc.createElement("Image");
            imgNode.setAttribute("ImagePath", parms.imagePath);
            return imgNode;
        }

        function sendConferenceAttributeMessage(attributeAction, pathListNode, attributeListNode, msgType)
        {
            var msgTitle = attributeAction + " Conference Attribute";
            var msgDoc = createXMLDocument("temp");

            var dataNd = msgDoc.createElement("Data");
            dataNd.appendChild(pathListNode);
            dataNd.appendChild(attributeListNode);

            g_dscClient.sendDSCMessage(msgTitle, dataNd, msgType);
        }

    };
}(jQuery));